module.exports = function(app) {
	'use strict';

	app.controller('pages.employee.enrollmentsInProcess', ['$state', '$scope', 'sessionData', 'services', '$window', 'modal', '$filter', 'addFlowCommander',
		'employee', 'coremetrics',
		function ($state, $scope, sessionData, services, $window, modal, $filter, addFlowCommander, employee, coremetrics) {

			if (!sessionData.entitlements.employees.view) { $state.go('home'); }
			if ($state.current.name === 'employee.enrollmentsInProcess') {
				if ($scope.getEnrollsIsRunning == true) {
					return;
				} else {
					$scope.isEnrollmentsInProcessPage = true;
					coremetrics.pageviewTag("EMPLOYERS:ENROLLMENT:ENROLLMENTS IN PROCESS", "EMPLOYERS:ENROLLMENT");
				}
			}

			$scope.employee = employee;

			$scope.sidebar = {
				breadCrumb: {
					primary: { title: 'Enrollments In Process', state: 'employee.enrollmentsInProcess' }
				}
			};
			if ($state.previous && $state.previous.name === 'employee.enrollment') {
				$scope.sidebar.breadCrumb.primary = { title: 'Enrollment', state: 'employee.enrollment' };
				$scope.sidebar.breadCrumb.secondary = { title: 'Enrollments In Process', state: 'employee.enrollmentsInProcess' };
			}

			$scope.feedback = {};
			$scope.participantsCount = {};
			$scope.objFiltering = {
				orderBy: 'lastName',
				reverse: true,
				selectAllRows: false,
				rowSelectionEnabled: true,
				titles: [
					{
						name: "Subscriber Name",
						dataKey: "lastName"
					}
					,{
						name: "Member ID",
						dataKey: "memberID"
					}
					,{
						name: "Status",
						dataKey: "status"
					}
				],
				pagination: {
					itemsPerPage: 20,
					page: 1
				},
				arrEnrolls: []
			}
			$scope.feedback = {};
			$scope.currentPage = $state.current.name;
			$scope.openFullEnrollmentsPage = function() {
				$state.go('employee.enrollmentsInProcess');
			}
			var showParticipantsCount = function(participantCntData){
				var enrollmentCount = participantCntData;// getParticipantsCount(arrEns);
                $scope.participantsCount["enrollSaved"] = enrollmentCount.enrollSaved;
                $scope.participantsCount["enrollSubmitted"] = enrollmentCount.enrollSubmitted;
				$scope.participantsCount["enrollPartialSubmit"] = enrollmentCount.enrollPartialSubmit;
				$scope.participantsCount["enrollmentTotal"] = enrollmentCount.enrollmentTotal;
			}
			var handleFetchedEnrollments = function(arrEns) {
				arrEns = $filter('orderBy')(arrEns, 'lastName');
				for (var i=0; i<arrEns.length; i++) {
					//if(arrEns[i].ssn != undefined){
						var newId = (arrEns[i].ssn).substring((arrEns[i].ssn.length - 4),arrEns[i].ssn.length);
						newId = '*****' + newId;
						arrEns[i].memberID = newId;
						// add stuff here to make a Delete button appear in the mobile view
						if (arrEns[i].status == 'SAVED') {
							var theButton = {
								type: "aButton",
								theLabel: 'Delete'
							}
							arrEns[i].controlsInRow = [];
							arrEns[i].controlsInRow.push(theButton);
						}
					//}
				}
				// this controller is used in enrollmentLanding and in enrollsInProcess
				if ($scope.currentPage == 'employee.enrollment') {
					// this is the 3-panel landing page. We only show the first 5 enrolls
					var theLen = arrEns.length;
					// if length is 5 or less we display,  # enrollments
					if (theLen <= 5) {
						var correctPluralOrSingular = (theLen == 1) ? 'enrollment' : 'enrollments';
						$scope.countAndAmount = ' of ' + theLen + ' ' + correctPluralOrSingular;
						$scope.hasMoreThanFive = false;
					} else {
						var displayed = (theLen >= 5) ? '5' : theLen;
						$scope.countAndAmount = ' of ' + theLen + ' enrollments';
						$scope.hasMoreThanFive = true;
					}
					var arrFiveEns = arrEns.splice(0, 5);
					$scope.objFiltering.arrEnrolls = arrFiveEns;
				} else {
					$scope.countAndAmount = ' of ' + arrEns.length + ' enrollments';
					$scope.objFiltering.arrEnrolls = arrEns;
				}				
			}
			// var getParticipantsCount = function(enrollObj){
			// 	if(enrollObj.length != 0){
			// 		var participantCt = enrollObj.filter(function(g,i){
			// 			if(g.participantsCount != undefined){return g;}
			// 		}); 
			// 		return participantCt[0];               
			// 	}
			// }
			// var getParticipantsData = function(enrollObj){
			// 	if(enrollObj.length != 0){
			// 		var participantData = enrollObj.filter(function(g,i){
			// 			if(g.participantsCount == undefined){return g;}
			// 		}); 
			// 		return participantData;               
			// 	}
			// }
			$scope.hasEnrollments = false;
			var getEnrollments = function() {
				// when this page loads stand-alone, this method runs twice, so we don't let it do that
				//if ($scope.getEnrollsIsRunning == true) {
				//	return;
				//}
				$scope.getEnrollsIsRunning = true;
				services.eprsvc.enrollments().fetch().then(function (response) {
					$scope.getEnrollsIsRunning = false;
					if (response && response.data && response.data.payload && response.data.payload.enrollmentsInProgress
						&& response.data.payload.enrollmentsInProgress.length ) {
							$scope.hasEnrollments = true;
							handleFetchedEnrollments(response.data.payload.enrollmentsInProgress);
							showParticipantsCount(response.data.payload.participantsCount);
						}
					else {
						if (response.data.payload.enrollmentsInProgress.length == 0) {
							$scope.feedback.showFeedback("There are no enrollments in process to display.", "notification");
							$($window).scrollTop(0);
						}
						else {
							$scope.feedback.showFeedback("The service returned something unexpected.", "failure");
							$($window).scrollTop(0);
						}
					}
				}, function (err) {
					$scope.getEnrollsIsRunning = false;
					if (err.data && err.data.baseMessage && err.data.baseMessage.returnCodeDescription) {
						if ((typeof $scope.feedback.showFeedback) == 'undefined') { return; }
							switch (err.data.baseMessage.returnCode) {
								case 10023:
									$scope.feedback.showFeedback('We\'re sorry Something unexpected happened.', "notification");
									break;
								case 100231:
									$scope.feedback.showFeedback("There are no enrollments in process to display.", "notification");
									break;
								default:
									$scope.feedback.showFeedback('We\'re sorry Something unexpected happened.', "notification");
									console.error('ERROR: enrollmentsInProcess returned: ' + err.data.baseMessage.returnCodeDescription)
									break;
							}


						$($window).scrollTop(0);
					} else {
						$scope.feedback.showFeedback("We are unable to process the request right now, Please try again later.", "failure");
						$($window).scrollTop(0);
					}
				}  );  }

				getEnrollments();

			$scope.deleteRollIsRunning = false;
			$scope.hitDeleteRollService = function() {
				$scope.closeModal();
				$scope.deleteRollIsRunning = true;
				var theSsn = $scope.theRollObj.ssn;
                services.eprsvc.enrollments().delSSN(theSsn).then(
					function (respObj) {
						$scope.deleteRollIsRunning = false;
						var fullName = $scope.theRollObj.firstName + ' ' + $scope.theRollObj.lastName;
						coremetrics.finishConversion('EMPLOYERS:ENROLLMENT:DELETE ENROLLMENTS IN PROGRESS','EMPLOYERS:ENROLLMENT');
						coremetrics.pageviewTag('EMPLOYERS:ENROLLMENT:LANDING PAGE','EMPLOYERS:ENROLLMENT');
						$scope.feedback.showFeedback("The information for "+ fullName +" has been successfully deleted.", "success");
						setTimeout(function() {
							$scope.feedback.hideFeedback();
						}, 1500);
						$scope.hasEnrollments = false;
						getEnrollments();
						// respObj.data.baseMessage.returnCode == 200
						var tt = respObj;
					},
					function(err) {
						$scope.deleteRollIsRunning = false;
						throw new Error(err);
						var hh = err;
					}
				)
			};
			$scope.theSsn = null;
			$scope.rusModal = null;
			$scope.deleteEnroll = function(theRollObj) {
				coremetrics.startConversion('EMPLOYERS:ENROLLMENT:DELETE:ENROLLMENTS IN PROGRESS','EMPLOYERS:ENROLLMENT');
				coremetrics.pageviewTag('EMPLOYERS:ENROLLMENT:ENROLLMENTS IN PROGRESS','EMPLOYERS:ENROLLMENT');
				theRollObj.fullName = theRollObj.firstName + ' ' + theRollObj.lastName;
				$scope.theRollObj = theRollObj;
				$scope.rusModal = modal.open({
					templateUrl: "manage-employees/enrollment.employerTemplate.html/pages/employee/modals/areYouSureModal",
					scope: $scope
				});
			}

			$scope.goToAddEmployee = function(ssn) {
				addFlowCommander.enrollmentInProcess.resume(ssn);
			};

		} ] );
};



